enum ApprovalRole {
  FactualAuditor = "FACTUAL_AUDITOR",
  CommandOperator = "COMMAND_OPERATOR",
  ChiefAccountant = "CHIEF_ACCOUNTANT",
}

export default ApprovalRole;
